import React, { useState, useEffect, useCallback } from 'react';
import AccordionItem from 'components/accordionItem/AccordionItem';
import { PaymentCategoryType } from 'consts';

import { IAccordionProps } from './Accordion.types';

function Accordion({
  items,
  defaultPaymentMethodType,
  selectedPaymentMethodType,
  hasGroupedCardMethods,
}: IAccordionProps) {
  const [activeMethodType, setActiveMethodType] = useState<string>('');

  useEffect(() => {
    if (defaultPaymentMethodType && !activeMethodType) {
      setActiveMethodType(defaultPaymentMethodType);
    } else if (selectedPaymentMethodType) {
      setActiveMethodType(selectedPaymentMethodType);
    }
  }, [defaultPaymentMethodType, selectedPaymentMethodType, activeMethodType]);

  useEffect(() => {
    if (selectedPaymentMethodType === undefined) {
      setActiveMethodType('');
    }
  }, [selectedPaymentMethodType]);

  const handleClick = useCallback((type: string, cb: () => void) => {
    setActiveMethodType(type);
    cb?.();
  }, []);

  function isChecked(itemType: string): boolean {
    return (
      activeMethodType === itemType ||
      (hasGroupedCardMethods &&
        activeMethodType === PaymentCategoryType.CLICK_TO_PAY &&
        itemType === PaymentCategoryType.CARD)
    );
  }

  return (
    <div className="accordion-container">
      {items.map((item, index) => (
        <AccordionItem
          {...item}
          index={index}
          handleClick={handleClick}
          key={item.type}
          isDefaultStyle={!activeMethodType}
          isChecked={isChecked(item.type)}
          isDisabled={item.isDisabled}
        />
      ))}
    </div>
  );
}

export default Accordion;
